export enum CompanyType {
    Default = 0,
    AppRiver = 1,
    Microsoft = 2,
    Inty = 3,
}
